exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".top-menu{min-height:50px}.top-menu li{font-size:20px}.top-menu li a{border-bottom:5px solid transparent;font-size:18px;height:45px;padding:0 10px}.top-menu li a:hover{color:#ccc;border-bottom:5px solid var(--site-color-primary);background-color:#222}.top-menu li:first-of-type{font-weight:700}.top-menu .top-menu-item--hot{padding-right:30px;background-repeat:no-repeat;background-position:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-8d951a38","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/menu/store-menu.vue
// module id = 94
// module chunks = 0